import { parseStoreEntryUrl } from "@utils/storeEntry";
import { isStorePanelLocation } from "@utils/storePanelLocation";

const captureStoreEntry = () => {
  if (typeof window === "undefined" || !isStorePanelLocation()) return null;
  const entry = parseStoreEntryUrl(window.location.href);
  if (entry && (entry.hasHandoff || entry.hasReturnUrl))
    window.history.replaceState(window.history.state, "", entry.cleanHref);
  return entry;
};

export const storeEntryBootstrap = captureStoreEntry();
